export const TABS = ["Manually", "From AS Filter"];
export const tabToTitle = ["Add Prefix Filters", "Add Prefix Filters"];
